// extracted by mini-css-extract-plugin
export default {"latestNewsSection":"Latestnews_latestNewsSection__fFJOH","heading":"Latestnews_heading__9nBYI","newsImage":"Latestnews_newsImage__fA5rv","content":"Latestnews_content__JDN75"};